export const SYSTEM_PROPERTIES_SET = 'SYSTEM_PROPERTIES_SET';
export const SYSTEM_PROPERTIES_TYPE_RETURN_REASON = 'return_reason';
